export default function (self, fields) {
  //TODO: Disable if rostering is not enabled

  const Fields = {
    title: `Unsubscribed`,
    minimum: 1,
    maximum: 1,
    key: "join_unsubscribe_sms",
    asObject: true,
    type: "group",
    fields: [
      {
        title: "Phone Number",
        minimum: 0,
        maximum: 0,
        key: "numbers",
        type: "string",
      },
    ],
  };

  fields.push(Fields);
}
